import { lesson18Activity1, lesson18Activity2, lesson18Activity3, lesson18Activity4 } from './assignments'
import { createChessboard } from '../../utils';

let lessonConfig = [
    {
        id: 0,
        previous: null,
        next: 2,
        video: {
            src: 'img/videos/lesson_18/1.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 1
        }
    },
    {
        id: 1,
        previous: 0,
        next: 2,
        audio: { src: 'img/audio/lesson_18/1.mp3', start: true, controls: false },
        chessboard: {
            board: lesson18Activity1({
                showIndicators: {allSides: true},
                position: '8/8/8/8/8/8/8/8',
                assignmentClass: 'custom-sparepieces',
                next: 2
            })
        }
    },
    {
        id: 2,
        previous: 0,
        next: 11,
        video: {
            src: 'img/videos/lesson_18/2.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 3
        }
    },
    {
        id: 3,
        previous: 2,
        next: 11,
        audio: { src: 'img/audio/lesson_18/2.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Select the correct option.',
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 0,
            next: 4,
            answer: [
                'YES, the White pawn can sucessfully promote.',
                'NO, the White pawn can\'t successfully promote.'
            ],
            rightAnswer: 'NO, the White pawn can\'t successfully promote.',
            magnusWrongAnswer: {
                data: 'Oops! Take a look.',
                styleClass: 'xs',
                waitTime: 4000
            },
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'lg'
        },
        chessboard: {
            board: createChessboard({
                showIndicators: { allSides: true },
                position: '8/3k4/8/8/7P/8/3K4/8',
                assignmentClass: 'custom-sparepiece',
            })
        }
    },
    {
        id: 4,
        previous: 2,
        next: null,
        chessboard: {
            board: lesson18Activity2({
                showIndicators: { allSides: true },
                position: '8/3k4/8/8/7P/8/3K4/8',
                assignmentClass: 'custom-sparepiece',
                from: ['h4','d7','h5','e7','h6','f7','h7','g7'],
                to: ['h5', 'e7', 'h6','f7','h7','g7','h8','h8'],
                next: 5
            })
        }
    },
    {
        id: 5,
        previous: 2,
        next: 11,
        audio: { src: 'img/audio/lesson_18/3.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Select the correct option.',
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 1,
            next: 6,
            answer: [
                'YES, the Black pawn can sucessfully promote.',
                'No, the Black pawn can\'t successfully promote.'
            ],
            rightAnswer: 'YES, the Black pawn can sucessfully promote.',
            magnusWrongAnswer: {
                data: 'Oops! Take a look.',
                styleClass: 'xs',
                waitTime: 4000
            },
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'lg'
        },
        chessboard: {
            board: createChessboard({
                showIndicators: { allSides: true },
                position: '8/8/4k3/8/8/6p1/3K4/8',
                assignmentClass: 'custom-sparepiece'
            })
        }
    },
    {
        id: 6,
        previous: 2,
        next: null,
        chessboard: {
            board: lesson18Activity2({
                showIndicators: { allSides: true },
                position: '8/8/4k3/8/8/6p1/3K4/8',
                resultFen: '8/8/4k3/8/8/8/4K3/6q1',
                assignmentClass: 'custom-sparepiece',
                from: ['g3','d2','g2'],
                to: ['g2','e2','g1'],
                next: 7
            })
        }
    },
    {
        id: 7,
        previous: 2,
        next: 11,
        audio: { src: 'img/audio/lesson_18/4.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Select the correct option.',
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 2,
            next: 8,
            answer: [
                'YES, the Black pawn can sucessfully promote.',
                'No, the Black pawn can\'t successfully promote.'
            ],
            rightAnswer: 'No, the Black pawn can\'t successfully promote.',
            magnusWrongAnswer: {
                data: 'Oops! Take a look.',
                styleClass: 'xs',
                waitTime: 4000
            },
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'lg'
        },
        chessboard: {
            board: createChessboard({
                showIndicators: { allSides: true },
                position: '8/8/8/2K1kp2/7P/8/8/8',
                assignmentClass: 'custom-sparepiece'
            })
        }
    },
    {
        id: 8,
        previous: 2,
        next: null,
        chessboard: {
            board: lesson18Activity2({
                showIndicators: { allSides: true },
                position: '8/8/8/2K1kp2/7P/8/8/8',
                resultFen: '8/8/8/4k3/7P/8/8/5K2',
                assignmentClass: 'custom-sparepiece',
                from: ['c5','f5','c4','f4','d3','f3','d2','f2','e2'],
                to: ['c4','f4','d3','f3','d2','f2','e2','f1','f1'],
                next: 9
            })
        }
    },
    {
        id: 9,
        previous: 2,
        next: 11,
        audio: { src: 'img/audio/lesson_18/4.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Select the correct option.',
            timeout: 0,
            className: 'no-animation'
        },
        options: {
            id: 3,
            next: 10,
            answer: [
                'YES, the White pawn can sucessfully promote.',
                'No, the White pawn can\'t successfully promote.'
            ],
            rightAnswer: 'No, the White pawn can\'t successfully promote.',
            magnusWrongAnswer: {
                data: 'Oops! Take a look.',
                styleClass: 'xs',
                waitTime: 4000
            },
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'lg'
        },
        chessboard: {
            board: createChessboard({
                showIndicators: { allSides: true },
                position: '8/8/8/2K1kp2/7P/8/8/8',
                assignmentClass: 'custom-sparepiece'
            })
        }
    },
    {
        id: 10,
        previous: 2,
        next: null,
        chessboard: {
            board: lesson18Activity2({
                showIndicators: { allSides: true },
                position: '8/8/8/2K1kp2/7P/8/8/8',
                resultFen: '7k/8/8/2K2p2/8/8/8/8',
                assignmentClass: 'custom-sparepiece',
                from: ['h4','e5','h5','f6','h6','f7','h7','g7'],
                to: ['h5','f6','h6','f7','h7','g7','h8','h8'],
                next: 11
            })
        }
    },
    {
        id: 11,
        previous: 2,
        next: 12,
        video: {
            src: 'img/videos/lesson_18/3.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 12
        }
    },
    {
        id: 12,
        previous: 11,
        next: 13,
        audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
        qa: {
            id: 0,
            question: 'What is Black\'s best move?',
            answer: [
                'pawn to h8 = Q',
                'pawn to h6',
                'pawn to h5',
                'King to c6'
            ],
            rightAnswer: 'pawn to h5',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                  showIndicators: true,
                  position: '8/2k1K2p/8/8/8/8/4P3/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 13,
        previous: 11,
        next: 14,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 1,
            question: 'It is Black\'s turn to move and White cannot stop Black from getting a new Queen only if;',
            answer: [
                'Black plays Kf7',
                'Black plays pawn to a7',
                'Black plays pawn to e2',
                'Black plays pawn to a5'
            ],
            rightAnswer: 'Black plays pawn to a5',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                  showIndicators: true,
                  position: '6k1/8/p7/8/8/4p1K1/8/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 14,
        previous: 11,
        next: 15,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 2,
            question: 'Black to move will get a new Queen only if;',
            answer: [
                'Black moves his King to d6',
                'White makes a big mistake',
                'Black plays pawn captures pawn',
                'Black pushes his pawn to a3'
            ],
            rightAnswer: 'Black pushes his pawn to a3',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                  showIndicators: true,
                  position: '8/8/4k3/8/p3K3/1P6/8/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 15,
        previous: 11,
        next: 16,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 3,
            question: 'Black moves his King to f2 and then;',
            answer: [
                'The White pawn moves one square and Black cannot catch him.',
                'The White King will block the Black King out of the action.',
                'The White pawn moves two squares and Black cannot catch him.',
                'The White pawn moves two squares and Black can catch him.'
            ],
            rightAnswer: 'The White pawn moves two squares and Black cannot catch him.',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'xl',
            chessboard: {
                board: createChessboard({
                  showIndicators: true,
                  position: '8/8/8/8/8/7K/P7/6k1'
                }),
                hint: true
            },
        }
    },
    {
        id: 16,
        previous: 11,
        next: 17,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 4,
            question: 'What is the missing number in this sequence?',
            answer: [
                '12',
                '15',
                '16',
                '18'
            ],
            rightAnswer: '16',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: lesson18Activity3({
                  position: '8/8/8/8/8/8/8/8',
                  squares: [ '.square-a5', '.square-b4', '.square-c3', '.square-d2', '.square-e1' ]
                }),
                hint: true
            },
        }
    },
    {
        id: 17,
        previous: 11,
        next: 18,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 5,
            question: 'What is the last number in this sequence?',
            answer: [
                '27',
                '30',
                '36',
                '41'
            ],
            rightAnswer: '36',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: lesson18Activity4({
                    position: '8/8/8/8/8/8/8/8',
                    squares: ['.square-f6', '.square-e5', '.square-d4', '.square-c3', '.square-b2', '.square-a1' ]
                }),
                hint: true
            },
        }
    },
    {
        id: 18,
        previous: 11,
        next: 19,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 6,
            question: 'It is White\'s turn. Which pawn should she move RIGHT NOW?',
            answer: [
                'a-pawn',
                'b-pawn',
                'c-pawn',
                'd-pawn'
            ],
            rightAnswer: 'b-pawn',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                  showIndicators: true,
                  position: '8/5k2/3p2p1/pPp2p2/5K2/2P3P1/P2P4/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 19,
        previous: 11,
        next: 20,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 7,
            question: 'Which player has more points on the board?',
            answer: [
                'White has two more points',
                'Black has two more points',
                'Black has one more point',
                'White has one more point'
            ],
            rightAnswer: 'Black has one more point',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                  showIndicators: true,
                  position: 'r2qkb1r/pppppppp/8/8/8/8/PPPPPPPP/NNNNKNNN'
                }),
                hint: true
            },
        }
    },
    {
        id: 20,
        previous: 11,
        next: 21,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 8,
            question: 'After all the Rooks, all the Bishops, all the Knights and both the Queens in a chess game have been captured the situation is called:',
            answer: [
                'Dinnertime!',
                'Almost the end',
                'A King and pawn endgame',
                'The Middle Ages'
            ],
            rightAnswer: 'A King and pawn endgame',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                  showIndicators: true,
                  position: '6k1/ppp2p1p/3p2p1/8/4PP2/P5P1/1PP4P/2K5'
                }),
                hint: true
            },
        }
    },
    {
        id: 21,
        previous: 11,
        next: 22,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 9,
            question: 'After a King and pawn endgame appears on the board which winning plan makes sense?',
            answer: [
                'Try to checkmate with just pawns.',
                'Move in circles to tire out your opponent.',
                'Suggest your opponent give up.',
                'Work to promote a pawn into a new Queen.'
            ],
            rightAnswer: 'Work to promote a pawn into a new Queen.',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'lg',
            chessboard: {
                board: createChessboard({
                  showIndicators: true,
                  position: '6k1/ppp2p1p/3p2p1/8/4PP2/P5P1/1PP4P/2K5'
                }),
                hint: true
            },
        }
    },
    {
        id: 22,
        previous: 11,
        next: null,
        audio: { src: null, stop: true },
        qa: {
          position: 'center',
          result: true,
          nextLesson: 'Lesson Nineteen',
          styleClass: 'xl'
        }
      }

];

let assets = [
    '/img/background_17.png',
    '/img/background_18.png',
    '/img/background_19.png'
];

let config = {
    config: lessonConfig,
    assets: assets
}

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_18/index.js